import { Notification } from "./Notification";
export default Notification;

